export const quickActionType = {
	PATTERN: 'pattern'
};

export const quickAction = {
	MAKE: 'make'
};
